import React from 'react';
import { AuditTrail } from '../modules/audit';

export const AuditTrailPage = () => {
    return (
        <AuditTrail />
    );
};
